import React, { useContext, useState, useEffect, useRef } from "react";
import { Form } from "antd";
import API_KEY from "../../../../../api/index";
import { getConvertedValue } from "utils/helpers";
import RenderFields from "./RenderFields";
import { update } from "@firebase/database";
const EditableContext = React.createContext(null);

export const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  type,
  defaults,
  saving,
  setSaving,
  isSizeChanged,
  setSizeChanged,
  isPriceChanged,
  setPriceChanged,
  deleted,
  setDeleted,
  dataSource,
  attrValueId,
  setAttrValueId,
  disable,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);

  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  useEffect(() => {
    if (isSizeChanged && type == "size") {
      if (dataIndex.split("_").length > 1) {
        let parent = dataIndex.split("_")[0];
        let newValue = form.getFieldsValue();
        form.setFieldsValue({
          [`${parent}_length`]: record[parent]?.length,
          [`${parent}_width`]: record[parent]?.width,
          [`${parent}_height`]: record[parent]?.height,
          [dataIndex]: record[dataIndex],
        });
      } else {
        form.setFieldsValue({
          [`${dataIndex}_length`]: record[dataIndex]?.length,
          [`${dataIndex}_width`]: record[dataIndex]?.width,
          [`${dataIndex}_height`]: record[dataIndex]?.height,
          // [`${dataIndex}_unit`]: record[dataIndex]?.unit,
        });
      }
      if (isSizeChanged) {
        setSizeChanged(false);
      }
      handleSave(record);
      patchAndPostAttributes(record);
      setSizeChanged(false);
    }
  }, [isSizeChanged]);

  useEffect(() => {
    if (isPriceChanged && type == "price") {
      form.setFieldsValue({ [dataIndex]: record[dataIndex] });
      handleSave(record);
      patchAndPostAttributes(record);
      setPriceChanged(false);
    }
  }, [isPriceChanged]);

  // useEffect(() => {
  //   if (record && dataIndex) {
  //     if (!editing) {
  //       if (dataIndex && record) {

  //       }
  //     }
  //   }
  // }, [dataSource]);

  const updateSubCategory = (values, productId) => {
    setSaving(true);
    API_KEY.URL.patch(`${API_KEY.path.collection_products}/${productId}`, {
      sub_category: values.join(","),
    })
      .then((res) => {
        // updateFormFields(values);
        toggleEdit();
        setSaving(false);
      })
      .catch((err) => {
        setSaving(false);
      });
  };
  const getValue = (children) => {
    if (type === "size") {
      let isComposite = dataIndex.split("_").length > 1;
      let size = record[dataIndex];
      return isComposite
        ? size
        : [size?.length, size?.width, size?.height].filter(Boolean).join("x");
    } else if (type === "csv") {
      let value = record[dataIndex] || "";
      return typeof value === "string" ? value : value.join(", ");
    } else {
      return children;
    }
  };

  const updateFormFields = (values) => {
    if (dataIndex && values) {
      switch (type) {
        case "size":
          form.setFieldsValue({
            [`${dataIndex}_length`]: values[dataIndex]?.length,
            [`${dataIndex}_width`]: values[dataIndex]?.width,
            [`${dataIndex}_height`]: values[dataIndex]?.height,
            [`${dataIndex}_unit`]: record[`${dataIndex}_unit`],
          });
          break;
        case "csv":
          form.setFieldsValue({
            [dataIndex]:
              typeof values[dataIndex] === "string"
                ? values[dataIndex]
                  ? values[dataIndex].split(",")
                  : []
                : values[dataIndex],
          });
          break;
        default:
          if (dataIndex) {
            form.setFieldsValue({
              [dataIndex]: values[dataIndex],
            });
          }
          break;
      }
    }
  };

  const toggleEdit = () => {
    if (type === "size") {
      setEditing(true);
    } else setEditing(!editing);
    switch (type) {
      case "size":
        if (dataIndex.split("_").length > 1) {
          let parent = dataIndex.split("_")[0];
          let newValue = form.getFieldsValue();
          form.setFieldsValue({
            [`${parent}_length`]: record[parent]?.length,
            [`${parent}_width`]: record[parent]?.width,
            [`${parent}_height`]: record[parent]?.height,
            [dataIndex]: newValue[dataIndex],
          });
        } else {
          form.setFieldsValue({
            [`${dataIndex}_length`]: record[dataIndex]?.length,
            [`${dataIndex}_width`]: record[dataIndex]?.width,
            [`${dataIndex}_height`]: record[dataIndex]?.height,
            // [`${dataIndex}_unit`]: record[dataIndex]?.unit,
          });
        }
        if (isSizeChanged) {
          setSizeChanged(false);
        }
        break;
      case "price":
        form.setFieldsValue({ [dataIndex]: record[dataIndex] });
        break;
      case "csv":
        form.setFieldsValue({
          [dataIndex]:
            typeof record[dataIndex] === "string"
              ? record[dataIndex]
                ? record[dataIndex].split(",")
                : []
              : record[dataIndex],
        });
        break;
      default:
        if (dataIndex) {
          form.setFieldsValue({
            [dataIndex]: record[dataIndex],
          });
        }
        break;
    }
    // form.setFieldsValue({
    //   [dataIndex]: record[dataIndex],
    // });
  };

  const patchAndPostAttributes = (values) => {
    let keyIndex = dataIndex;
    let splitKeys = dataIndex.split("_");
    let isComposite = splitKeys.length > 1;
    let compositeValue = {};
    let attributeValue = "";
    let computedSize = "";
    let hasValues = true;
    if (isComposite) {
      keyIndex = splitKeys[0];
    }
    let editedValue = values[keyIndex];
    const currentAttribute =
      values.productData?.filter((item) => item.name === keyIndex)[0] || {};
    let productId = values?.product_id;

    const { attribute_id = "", attribute_value_id = "" } = currentAttribute;

    switch (type) {
      case "csv":
        attributeValue = editedValue.filter(Boolean).join(",");
        break;
      case "text":
        attributeValue = editedValue;
        break;
      case "price":
        attributeValue = isComposite ? values[keyIndex] : values[dataIndex];
        compositeValue = {
          currency: values[`${keyIndex}_currency`] || "",
          unit: values[`${keyIndex}_unit`] || "",
        };
        if (!attributeValue) return;
        break;
      case "size":
        compositeValue = {
          length: editedValue.length || "",
          width: editedValue.width || "",
          height: editedValue.height || "",
          unit: values[`${keyIndex}_unit`] || "",
        };
        const { length, width, height } = compositeValue;
        hasValues = [length, width, height].filter(Boolean).length;

        if (!hasValues && !attribute_value_id) {
          return;
        }
        computedSize = `${[
          compositeValue.length,
          compositeValue.width,
          compositeValue.height,
        ]
          .filter(Boolean)
          .join("x")} ${values[`${keyIndex}_unit`] || ""}`.trim();
        attributeValue = computedSize;
        break;
      default:
        attributeValue = editedValue;
    }

    let requestPayloadForPatch = {
      id: attribute_value_id || attrValueId?.[productId]?.[attribute_id],
      attribute_id: attribute_id,
      values: attributeValue,
      collections_products_id: values?.product_id,
      composite: compositeValue,
    };
    let requestPayloadForPost = {
      collections_products_id: values?.product_id,
      attribute_values_id: {
        attribute_id: attribute_id,
        values: attributeValue,
        composite: compositeValue,
      },
    };
    if (
      (attribute_value_id || attrValueId?.[productId]?.[attribute_id]) &&
      hasValues
    ) {
      setSaving(true);
      API_KEY.URL.patch(
        `${API_KEY.path.attribute_values}/${
          attribute_value_id || attrValueId?.[productId]?.[attribute_id]
        }`,
        requestPayloadForPatch
      )
        .then((res) => {
          // updateFormFields(values);
          setSaving(false);
        })
        .catch((err) => {
          setSaving(false);
        });
    } else {
      if (hasValues) {
        setSaving(true);
        API_KEY.URL.post(
          API_KEY.path.collections_products_attribute_values,
          requestPayloadForPost
        )
          .then((res) => {
            setSaving(false);
            if (!attrValueId[productId]) {
              attrValueId[productId] = {};
            }
            attrValueId[productId][attribute_id] =
              res?.data?.data?.attribute_values_id;
            // attrValueId[attribute_id] = res?.data?.data?.attribute_values_id;
            setAttrValueId(attrValueId);
          })
          .catch((err) => {
            setSaving(false);
          });
      }
    }
  };

  const saveComposite = async (value, key, compositeKey) => {
    try {
      let newValues = {},
        allValues = {};
      let splitKey = key.split("_");
      let parentKey = "";
      if (splitKey.length > 1) {
        parentKey = splitKey[0];
      }

      if (parentKey) {
        let oldValues = record[parentKey];
        let oldUnit = record[key];
        if (compositeKey === "unit" && oldUnit && oldUnit !== value) {
          Object.keys(oldValues).map(function (current, index) {
            oldValues[current] = getConvertedValue(oldValues[current], value);
          });
        }
        newValues = { ...oldValues, [compositeKey]: value };

        allValues = { ...record, [parentKey]: newValues, [key]: value };
        handleSave(allValues);
        patchAndPostAttributes(allValues);
        toggleEdit();
      } else {
        let newValues = form.getFieldsValue();
        newValues = {
          length: newValues[`${key}_length`] || "",
          width: newValues[`${key}_width`] || "",
          height: newValues[`${key}_height`] || "",
        };
        allValues = { ...record, [key]: newValues };
        handleSave(allValues);
        patchAndPostAttributes(allValues);
      }
    } catch (errInfo) {
      console.log("Composite save failed:", errInfo);
    }
  };

  const getDefaultOptions = (type, key) => {
    const values = defaults[key];

    switch (type) {
      case "csv":
        return values;
      case "size":
        return [
          ...new Set(
            values
              .filter((item) => item.split(" ").length > 1)
              .map((item) => item.split(" ")[1])
          ),
        ];
      default:
        return values || [];
    }
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      const valueToUpdate = values[dataIndex];
      const newValues = { ...record, [dataIndex]: valueToUpdate };

      if (dataIndex.toLowerCase() === "sub category") {
        updateSubCategory(valueToUpdate, record.product_id);
      } else {
        patchAndPostAttributes(newValues);
        toggleEdit();
      }
      handleSave(newValues);
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <div>
        <RenderFields
          type={type}
          dataIndex={dataIndex}
          inputRef={inputRef}
          children={children}
          save={save}
          saveComposite={saveComposite}
          updateSubCategory={updateSubCategory}
          record={record}
          defaults={defaults}
          toggleEdit={toggleEdit}
          form={form}
        />
      </div>
    ) : (
      <div
        className={disable ? "" : "editable-cell-value-wrap"}
        onClick={toggleEdit}
        // onMouseEnter={() => setEditing(true)}
        // onMouseOut={() => setEditing(false)}
        onBlur={() => !type === "size" && setEditing(false)}
      >
        {/* <RenderStaticCell
          type={type}
          dataIndex={dataIndex}
          
          children={children}
         
        /> */}

        {getValue(children)}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
